module.exports = __webpack_public_path__ + "media/images/athena_114-ec05e60c09144f1c14997a4721a48f61.png";